import { useMemo } from 'react';
import { IPromoModalProps } from '@cian/frontend-newbuilding-promo-modal-widget';
import { useSelector } from 'react-redux';
import { selectPromoInfo } from '../../../selectors/promoInfo';

export const usePreparedPromo = (): IPromoModalProps['promo'] | null => {
  const promo = useSelector(selectPromoInfo);

  return useMemo(() => {
    if (!promo) {
      return null;
    }

    return {
      authorName: `${promo.isFromBuilder ? 'Застройщик' : ''} ${promo.authorName}`.trim(),
      name: promo.name,
      type: promo.promoType,
      features: promo.features,
      banks: promo.banks.map(bank => ({
        id: bank.id,
        name: bank.name,
        logoUrl: bank.secondSquareImageUrl || bank.logoUrl || undefined,
      })),
      cianMortgageBank: promo.bank && {
        id: promo.bank.id,
        name: promo.bank.name,
        logoUrl: promo.bank.secondSquareImageUrl || promo.bank.logoUrl || undefined,
        isPartner: promo.bank.isPartner,
      },
      description: promo.description,
      availableJks: promo.availableJks,
      labels: [], // Добавить после реализации на беке в CD-236208
      fullCreditPriceTitle: undefined, // Добавить после реализации на беке в CD-236208
      availablePurchaseTerms: [], // Добавить после реализации на беке в CD-236208
      mortgageLegalInfo: undefined, // Добавить после реализации на беке в CD-236208
    };
  }, [promo]);
};
